import Service from '@/Network/Services/Service'
import request from '@/Network/Requests/request'

type Response = {
  id: number
  name: string
}

export default class FieldOptionsService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/field-options'
  }

  async getPositions(): Promise<Response[]> {
    try {
      const response = await request.get<Response[]>(this.getCompletePath('/positions'), {})
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as posições.')
    }
  }

  async getShifts(): Promise<Response[]> {
    try {
      const response = await request.get<Response[]>(this.getCompletePath('/shifts'), {})
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os turnos.')
    }
  }

  async getFormations(): Promise<Response[]> {
    try {
      const response = await request.get<Response[]>(
        this.getCompletePath('/ds-payment-doctor-formations'),
        {}
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as formações.')
    }
  }

  async getOperationalGroups(): Promise<Response[]> {
    try {
      const response = await request.get<Response[]>(this.getCompletePath('/operational-groups'))
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os grupos operacionais.')
    }
  }
}
